import { Link } from 'react-router-dom';
import { accessories, mensShirts } from '../../mocks/products';
import SmokeEffect from '../../components/base/SmokeEffect';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const featuredAccessories = accessories.slice(0, 3);
  const featuredShirts = mensShirts.slice(0, 3);
  const featuredHats = accessories.filter(item => item.category === 'Hats');

  return (
    <div className="min-h-screen bg-black relative">
      <SmokeEffect />
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/7501742ad941ccfc3322799ab9eb7c73.jpg"
            alt="Background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
        </div>

        <div className="relative z-10 text-center px-6 sm:px-8 max-w-5xl mx-auto w-full py-12">
          <img
            src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/cbc12e6e2441c5ee6f286cff30459b30.png"
            alt="Up N' Smoke"
            className="mx-auto mb-6 sm:mb-8 h-40 sm:h-48 md:h-56 drop-shadow-2xl"
          />
          
          <h1 className="font-orbitron text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 sm:mb-6 animate-neon-glow px-4">
            Up N&apos; Smoke Vape Shop
          </h1>
          
          <p className="font-rajdhani text-base sm:text-lg md:text-2xl text-gray-200 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed px-4">
            Your premier destination for <strong>vape accessories</strong>, themed apparel, and unique decals in <strong>Elkhart, Indiana</strong>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center px-4">
            <Link
              to="/shop"
              className="w-full sm:w-auto bg-gradient-to-r from-neon-purple to-neon-pink text-white px-8 sm:px-12 py-4 sm:py-5 rounded-full font-orbitron text-base sm:text-xl font-bold hover:shadow-2xl hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
            >
              Shop Now
            </Link>
            <a
              href="tel:5742187357"
              className="w-full sm:w-auto border-2 border-neon-purple text-white px-8 sm:px-12 py-4 sm:py-5 rounded-full font-orbitron text-base sm:text-xl font-bold hover:bg-neon-purple/20 hover:shadow-lg hover:shadow-neon-purple/30 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
            >
              Call (574) 218-7357
            </a>
          </div>
        </div>
      </section>

      {/* Featured Accessories */}
      <section className="relative py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-orbitron text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 px-4">
              Featured <span className="text-neon-purple">Accessories</span>
            </h2>
            <p className="font-rajdhani text-base sm:text-lg md:text-xl text-gray-300 px-4">
              Premium <strong>vape accessories</strong> including cases, hats, and decals
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8" data-product-shop>
            {featuredAccessories.map((product) => (
              <div
                key={product.id}
                className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-neon-purple/30 hover:border-neon-purple hover:shadow-2xl hover:shadow-neon-purple/30 transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-64 sm:h-72 md:h-80 w-full overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="font-orbitron text-lg sm:text-xl font-bold text-white mb-2">
                    {product.name}
                  </h3>
                  <p className="font-rajdhani text-sm sm:text-base text-gray-400 mb-4">{product.category}</p>
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-orbitron text-xl sm:text-2xl font-bold text-neon-pink">
                      ${product.price}
                    </span>
                    <button className="bg-gradient-to-r from-neon-purple to-neon-pink text-white px-4 sm:px-6 py-2 rounded-full font-rajdhani text-sm sm:text-base font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer">
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/accessories"
              className="inline-block bg-gradient-to-r from-neon-purple to-neon-pink text-white px-6 sm:px-8 py-3 rounded-full font-orbitron text-sm sm:text-base font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View All Accessories
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Shirts */}
      <section className="relative py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-transparent to-black/50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-orbitron text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 px-4">
              Featured <span className="text-neon-pink">Shirts</span>
            </h2>
            <p className="font-rajdhani text-base sm:text-lg md:text-xl text-gray-300 px-4">
              Cool <strong>vape-themed shirts</strong> for men and women
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8" data-product-shop>
            {featuredShirts.map((product) => (
              <div
                key={product.id}
                className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-neon-pink/30 hover:border-neon-pink hover:shadow-2xl hover:shadow-neon-pink/30 transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-64 sm:h-72 md:h-80 w-full overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="font-orbitron text-lg sm:text-xl font-bold text-white mb-2">
                    {product.name}
                  </h3>
                  <p className="font-rajdhani text-sm sm:text-base text-gray-400 mb-4">{product.category}</p>
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-orbitron text-xl sm:text-2xl font-bold text-neon-purple">
                      ${product.price}
                    </span>
                    <button className="bg-gradient-to-r from-neon-purple to-neon-pink text-white px-4 sm:px-6 py-2 rounded-full font-rajdhani text-sm sm:text-base font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer">
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/shirts"
              className="inline-block bg-gradient-to-r from-neon-purple to-neon-pink text-white px-6 sm:px-8 py-3 rounded-full font-orbitron text-sm sm:text-base font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View All Shirts
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Hats */}
      <section className="relative py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-orbitron text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 px-4">
              Featured <span className="text-neon-purple">Hats</span>
            </h2>
            <p className="font-rajdhani text-base sm:text-lg md:text-xl text-gray-300 px-4">
              Stylish <strong>vape hats</strong> and caps
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8" data-product-shop>
            {featuredHats.map((product) => (
              <div
                key={product.id}
                className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-neon-purple/30 hover:border-neon-purple hover:shadow-2xl hover:shadow-neon-purple/30 transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-64 sm:h-72 md:h-80 w-full overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 sm:p-6">
                  <h3 className="font-orbitron text-lg sm:text-xl font-bold text-white mb-2">
                    {product.name}
                  </h3>
                  <p className="font-rajdhani text-sm sm:text-base text-gray-400 mb-4">{product.category}</p>
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-orbitron text-xl sm:text-2xl font-bold text-neon-pink">
                      ${product.price}
                    </span>
                    <button className="bg-gradient-to-r from-neon-purple to-neon-pink text-white px-4 sm:px-6 py-2 rounded-full font-rajdhani text-sm sm:text-base font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer">
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/shop"
              className="inline-block bg-gradient-to-r from-neon-purple to-neon-pink text-white px-6 sm:px-8 py-3 rounded-full font-orbitron text-sm sm:text-base font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View All Hats
            </Link>
          </div>
        </div>
      </section>

      {/* Facebook Feed Section */}
      <section className="relative py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black/50 to-transparent">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-orbitron text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 px-4">
              Follow Us on <span className="text-neon-purple">Facebook</span>
            </h2>
            <p className="font-rajdhani text-base sm:text-lg md:text-xl text-gray-300 mb-6 sm:mb-8 px-4">
              Stay updated with our latest products and promotions
            </p>
          </div>

          <div className="max-w-2xl mx-auto bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-neon-purple/30 p-4 sm:p-6 md:p-8">
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fpeople%2FUp-N-Smoke-Vape-Shop%2F61584660412472%2F&tabs=timeline&width=500&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
              width="100%"
              height="600"
              style={{ border: 'none', overflow: 'hidden' }}
              scrolling="no"
              frameBorder="0"
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              title="Facebook Page"
            ></iframe>
          </div>

          <div className="text-center mt-6 sm:mt-8">
            <a
              href="https://www.facebook.com/people/Up-N-Smoke-Vape-Shop/61584660412472/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-neon-purple to-neon-pink text-white px-6 sm:px-8 py-3 rounded-full font-orbitron text-sm sm:text-base font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              Visit Our Facebook Page
            </a>
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section className="relative py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-orbitron text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 px-4">
              Visit Our <span className="text-neon-pink">Store</span>
            </h2>
            <p className="font-rajdhani text-base sm:text-lg md:text-xl text-gray-300 px-4">
              Located in <strong>Elkhart, Indiana</strong>
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
            <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-6 sm:p-8 border border-neon-purple/30">
              <h3 className="font-orbitron text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 text-center">Store Information</h3>
              
              <div className="space-y-4 sm:space-y-6 font-rajdhani text-base sm:text-lg">
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-neon-pink text-xl sm:text-2xl mr-3 sm:mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold mb-1">Address</p>
                    <p className="text-gray-300">3227 Northview Dr<br />Elkhart, IN 46514</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-phone-line text-neon-pink text-xl sm:text-2xl mr-3 sm:mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold mb-1">Phone</p>
                    <a href="tel:5742187357" className="text-gray-300 hover:text-neon-purple transition-colors cursor-pointer">
                      (574) 218-7357
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-mail-line text-neon-pink text-xl sm:text-2xl mr-3 sm:mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold mb-1">Email</p>
                    <a href="mailto:upnsmokevapes@gmail.com" className="text-gray-300 hover:text-neon-purple transition-colors cursor-pointer break-all">
                      upnsmokevapes@gmail.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-6 sm:mt-8 text-center">
                <a
                  href="https://www.google.com/maps/search/?api=1&query=3227+Northview+Dr+Elkhart+IN+46514"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-gradient-to-r from-neon-purple to-neon-pink text-white px-6 py-3 rounded-full font-orbitron text-sm sm:text-base font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Get Directions
                </a>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-neon-purple/30 min-h-[400px] sm:min-h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3004.5!2d-85.9767!3d41.7325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDQzJzU3LjAiTiA4NcKwNTgnMzYuMSJX!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '400px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Store Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
